/*! 
* WeX5 v3 (http://www.justep.com) 
* Copyright 2015 Justep, Inc.
* Licensed under Apache License, Version 2.0 (http://www.apache.org/licenses/LICENSE-2.0) 
*/ 
import {isArray} from "../../../lib/base/util";

	var removeAll = async function (data,disableRecordChange) {
		if(disableRecordChange) {
			data.clear();
		} else{
			var confirmDelete = data.confirmDelete;
			try{
				data.confirmDelete = false;
				await data.deleteAllData({mode: "master"});
			}finally{
				data.confirmDelete = confirmDelete;
			}
		}
	};

	var changeStateForNone =async function (data,defaultValue) {		
		if(isArray(defaultValue) && defaultValue.length>0){
			var primaryColumns=data.primaryColumns;
			for (var i = 0; i < defaultValue.length; i++) {		
				var searchValues=[];			
				primaryColumns.forEach(item=>searchValues.push(defaultValue[i][item]));
				var currentRow=await data.find(primaryColumns,searchValues);
				if(currentRow.length==1){
					currentRow[0].setState();
				}	
			}					
		}
	};

	var newRowData = async function (data,defaultValue,disableRecordChange,index) {
		if(isArray(defaultValue) && defaultValue.length>0){
			await data.newData({'defaultValues':defaultValue,'disableRecordChange':disableRecordChange,'index':index});
		}
	};
	
	var setValue = function (data, mapping, receiveData, rownum, row) {
		var from = mapping.from;
		var to = mapping.to;
		if (!from || from === "" || !to || to === "") return;
		if(receiveData[rownum].hasOwnProperty(from)){
			var val = getValue(receiveData[rownum],from);
			'function'===typeof(data.setValue)?data.setValue(to, val, row):(row[to]=val);
		}
	};

	var getValue = function (row, col) {
		if (!row) return;
		return row[col];
	};

	var createLocfrom = function (mappingDef, rowIndex, receiveData) {
		var locfrom = mappingDef.locfrom;
		if(!isArray(locfrom)){
			return getValue(receiveData[rowIndex],locfrom);
		}else{
			let ret = [];
			for(let name of locfrom.values()){
				ret.push(getValue(receiveData[rowIndex],name));
			}
			return ret;
		}
	};

	export async function receiveByMapping(page, mapping, receiveData, insertPos){
			if (!mapping || !receiveData) return;
			if(!isArray(receiveData)) receiveData = [receiveData]; 
			var mappingDef = mapping, model = page, i, j, o, mappings = mappingDef.mappings;

			if (!mappingDef.dataID || mappingDef.dataID === "" || !mappingDef.operation || mappingDef.operation === "")
				return;

			var dataTar = model.comp(mappingDef.dataID);
			if (!dataTar) return;
			
			let newData = [];
			if(mappingDef.disableRecordChange) dataTar.disableRecordChange();
			try{				
				if (mappingDef.operation === "new") {
					for (i = 0; i < receiveData.length; i++) {
						o = {};
						for (j = 0; j < mappings.length; j++) {
							setValue(o, mappings[j], receiveData, i, o);
						}
						newData.push(o);
					}
					await newRowData(dataTar,newData,mappingDef.disableRecordChange,insertPos);
				} else if (mappingDef.operation == "edit"||mappingDef.operation == "load") {
					let recordChange = dataTar.canRecordChange();
					if (mappingDef.operation == "load" && recordChange){
						dataTar.disableRecordChange();
					}
					for (i = 0; i < receiveData.length; i++) {
						let query = dataTar.find(mappingDef.locto, createLocfrom(mappingDef, i, receiveData), true);
						isArray(query) && (query = query.length>0?query[0]:null);
						if (query) {
							for (j = 0; j < mappings.length; j++) {
								setValue(dataTar, mappings[j], receiveData, i, query);
							}
						} else {
							o = {};
							for (j = 0; j < mappings.length; j++) {
								setValue(o, mappings[j], receiveData, i, o);
							}
							newData.push(o);
						}
					}
					if (mappingDef.operation == "load" && recordChange){
						dataTar.enabledRecordChange();
					}
					await newRowData(dataTar,newData,mappingDef.disableRecordChange,insertPos);
					if(mappingDef.operation == "load"){
						await changeStateForNone(dataTar,newData)
					}
				} else if (mappingDef.operation == "clear") {
					await removeAll(dataTar,mappingDef.disableRecordChange);
					for (i = 0; i < receiveData.length; i++) {
						o = {};
						for (j = 0; j < mappings.length; j++) {
							setValue(o, mappings[j], receiveData, i, o);
						}
						newData.push(o);
					}
					await newRowData(dataTar,newData,mappingDef.disableRecordChange,insertPos);
				} else if (mappingDef.operation == "modify") {
					for (i = 0; i < receiveData.length; i++) {
						for (j = 0; j < mappings.length; j++) {
							setValue(dataTar, mappings[j], receiveData, i);
						}
					}
				} else {
					return;
				}		
			}finally{
				dataTar.enabledRecordChange();
			}
		}
	
	/**
	 * config格式
	 * {message,mapping,fireEvent,page}
	 * 只处理mapping逻辑，不触发事件
	 */
	export async function processMappingMessage(config){
		config = config || {};
		if (config.message && config.page){
			let message = config.message || {};
			let data = message.data || [];
            if (message.type=="mapping"){
            	let insertPos = undefined === message.insertPos ? -1 : message.insertPos;
	            await receiveByMapping(config.page, config.mapping, data, insertPos);
            }
		}
	}
	
	export default {receiveByMapping};
